const breakpoints = {
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
    ],
    values: {
        xs: 0,
        sm: 640,
        md: 728,
        lg: 1024,
        xl: 1280,
    }
}

export default breakpoints;